import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SuperAdminLogin from './Authentication/SuperAdminlogin';
import SuperAdminDashboard from './page/Dashboard';
import AppLayout from './components/ui/layout/AppLayout';
import TicketsPage from './page/Ticketmanagment/TicketDash';
import BrandingPage from './page/Branding/BrandingDash';

import { Toaster } from './components/ui/Toaster';
import SuperAdminProfilePage from './page/SuperAdminProfile';
import UserDetailPage from './page/UserDetailPage';
import SuperAdminForgotPassword from './Authentication/SuperAdminForgotPassword';
import SuperAdminResetPasswordPage from './Authentication/SuperAdminResetPassword';
function App() {
  return (
<>
<Router>
  <Routes>
    <Route path='/' element={<SuperAdminLogin />}/>
    <Route path='/forget-password' element={<SuperAdminForgotPassword />}/>
       <Route path="/admin-reset-password" element={<SuperAdminResetPasswordPage />} />
    

    <Route  element={<AppLayout />}>
    <Route path='/Dashboard' element={<SuperAdminDashboard />}/>
    <Route path='/user-detail/:userId' element={<UserDetailPage />}/>
    <Route path='/Ticket-Mangament' element={<TicketsPage />}/>
    <Route path='/Branding' element={<BrandingPage />}/>
    <Route path='/profile' element={<SuperAdminProfilePage />}/>
    </Route>
    
  </Routes>
  <Toaster />
</Router>
</>
  );
}

export default App;
